@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (ListPackage && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div class="text-900 font-medium text-xl mb-3">
      <h3>Packages</h3>
    </div>
    <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
      <span class="pi pi-info-circle" style="margin-right:2px;"></span> Packages is where you define what you sell.  This is the section that brings all the other elements together, allowing us to calculate availability and price for a booking.
    </p>
    <div class="list-toolbar" style="text-align: right; margin-bottom: 20px;">
      <p-togglebutton class="p-component" [(ngModel)]="isDisabled" onLabel="Show Disabled" offLabel="Hide Disabled" offIcon="pi pi-times" onIcon ="pi pi-check" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'font-weight': 'normal', 'height': '50px'}" (click)="toggleDisabled()">
      </p-togglebutton>
      <span class="p-input-icon-left ml-auto" style="margin-right:20px; ">
        <i class="pi pi-search"></i>
        @if (ListPackage) {
          <input  pInputText type="text" (input)="packagesTable.filterGlobal($event.target.value, 'contains')" style="height: 50px;padding-left:33px;" placeholder="Package Name"/>
        }
      </span>
      <!-- One Export button; the exports themselves are listed underneath it. The menu is
      appended to the body so the table below cannot clip it. -->
      <button pButton type="button" style="height: 50px; margin-right: 6px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="exportMenu.toggle($event)">
        <span class="pi pi-file-excel" style="margin-right:8px;"></span>
        <span>Export</span>
        <span class="pi pi-chevron-down" style="margin-left:8px; font-size:0.8rem;"></span>
      </button>
      <p-menu #exportMenu [model]="exportItems" [popup]="true" appendTo="body"></p-menu>
      <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="addNewPackage()">
        <span class="pi pi-plus" style="margin-right:8px;"></span>
        <span>Add</span>
      </button>
      &nbsp;
      <button pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableMulti()">
        <span class="pi pi-trash" style="margin-right:8px;"></span>
        <span i18>Disable</span>
      </button>
    </div>
    <div class="surface-card p-4 shadow-2 border-round">
      <p-table #packagesTable
        [value]="ListPackage" sortField="name" [paginator]="true" [rows]="10"
        [showCurrentPageReport]="true" responsiveLayout="scroll"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        [rowsPerPageOptions]="[10,25,50]"
        [globalFilterFields]="['name']"
        [(selection)]="selectedItems"
        responsiveLayout="scroll"
        datakey="TagID"
        [selectionPageOnly]="true">
        <ng-template #header>
          <tr>
            <th width="1%">
              <p-tableheadercheckbox></p-tableheadercheckbox>
            </th>
            <th width="1%">
            </th>
            <th pSortableColumn="name" width="73%">Name
              <p-sorticon [field]="name"></p-sorticon>
            </th>
            <th width="5%"></th>
            <th width="5%"></th>
            <th width="5%"></th>
            <th width="5%"></th>
            <th width="5%"></th>
          </tr>
        </ng-template>
        <ng-template #body let-data>
          <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
            <td>
              <p-tablecheckbox [value]="data"></p-tablecheckbox>
            </td>
            <td>
              @if (data.waiverrequired==true) {
                <i class="pi pi-file-pdf" title="Requires Waiver"></i>
              }
            </td>
            @if (data.startTimes!=null) {
              <td>{{data.name}}</td>
            }
            @if (data.startTimes==null) {
              <td style="font-style: italic;">{{data.name}}&nbsp;<span style="color:red">[No Package Start Times]</span></td>
            }
            <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component"  (click)="editData(data.packageId);">
              <span class="pi pi-pencil" style="margin-right:8px;"></span>
              <span i18n>Edit</span>
            </button></td>
            <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-info p-button p-component" style="margin-left:-20px;width: 152px;white-space:nowrap;" [routerLink]="['/packagestarttimes/' + data.packageId]" >
              <span class="pi pi-clock" style="margin-right:8px;"></span>
              <span i18n>Start&nbsp;Times</span>
            </button></td>
            <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-secondary p-button p-component" style="margin-left:-20px;width: 108px;" [routerLink]="['/packageextras/' + data.packageId]" >
              <span class="pi pi-star" style="margin-right:8px;"></span>
              <span i18n>Extras</span>
            </button></td>
            <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-help p-button p-component" style="margin-left:-20px;width: 124px;" [routerLink]="['/packageupgrades/' + data.packageId]" >
              <span class="pi pi-arrow-up" style="margin-right:8px;"></span>
              <span i18n>Upgrades</span>
            </button></td>
            <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-warn p-button p-component" style="margin-left:-20px;" (click)="copydata(data.packageId)">
              <span class="pi pi-copy" style="margin-right:8px;"></span>
              <span i18n>Copy</span>
            </button></td>
            <td><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="margin-left:-20px;" (click)="disableData(data.packageId)">
              <span class="pi pi-trash" style="margin-right:8px;"></span>
              <span i18n>Disable</span>
            </button></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
}
